import Image from "next/image"
import Head from "next/head";
import upscbanner1 from "../../assets/images/home/Banner/UPSC-GSPCM-Webbanner.jpg";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import { useEffect, useState } from 'react';
// import phone from "../../assets/images/upsc/phone.png";
import downloadicon from "../../assets/images/download.png";
import styles from "./upsc-ias-ips-admission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
import NewiconA from "../../assets/images/header/modalnew.png";
import star from "../../assets/images/about/why-shankar-ias-academy/trainers.webp";
import meet from "../../assets/images/about/why-shankar-ias-academy/inter.webp";
import worl from "../../assets/images/about/why-shankar-ias-academy/infra.webp";
import guidance from "../../assets/images/about/why-shankar-ias-academy/test.webp";
import mentor from "../../assets/images/about/why-shankar-ias-academy/interview.webp";
import test from "../../assets/images/about/why-shankar-ias-academy/test series.webp";
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"));
import Program_Features from "./upsc-ias-ips-admission-program-features";
//import Classroom_form from "./upsc-ias-ips-admission-form";
import Link from "next/link";
import { useRouter } from "next/router";
import useDownloader from "react-use-downloader";
import Emioption from "../../components/Service/emioption";
import Optionalplus from "../../components/Service/optionalplus";
const UPSCClassroomOnline = () => {
  
  const {download} = useDownloader();

  const fileUrl = "https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-Chennai-Admission-2026.pdf";
  const filename = "Brochure-Chennai-Admission-2026.pdf"

  const feestructure =[
    {date:"16.02.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"25.03.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"31.03.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:(<><div>23.04.2026</div> <div><span style={{fontSize:"11px"}}>(*Subject to change<br/> based on the election date)</span></div> </>) ,  cont:"Regular",cont1:"08:00 am to 10:30 am"},
    {date:"16.05.2026", cont:"Weekend", cont1:"02:00 pm to 07:30 pm"},
    {date:"04.06.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"04.06.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    {date:"24.06.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    //{date:"20.07.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    //{date:"18.08.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    

  ]

  const feestructure2 =[

    {date:"06.04.2026",cont:"Regular",cont1:"02.30 pm to 04.30 pm"},
    {date:"18.06.2026",cont:"Regular",cont1:"02.30 pm to 04.30 pm"},
    {date:"18.06.2026",cont:"Regular",cont1:"05.30 pm to 07.30 pm"},
    {date:"27.06.2026",cont:"Weekend",cont1:"09:00 am to 01:00 pm"},
   
    
  ]

  const feestructure3 =[
     {date:"05.07.2026",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Tamil literature",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Mathematics",cont2:"08:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Public Administration",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"PSIR",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Anthropology",cont2:"02:30 pm to 04:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Agriculture",cont2:"06:30 pm to 08:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"English",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Law",cont2:"02:30 pm to 05:00 pm"}
     
   
  ]

  const jsonLd ={
    "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "Best UPSC Academy in India | Shankar IAS Academy",
              "url": "https://www.shankariasacademy.com/upsc-admission-anna-nagar/",
              "Image":
              "https://www.shankariasacademy.com/_next/static/media/Pre-book-2024_Webbanner-Without-button.6686241b.webp",
              "description": "Join Shankar IAS Academy, the best IAS academy in India, for expert UPSC coaching, quality study material, and proven strategies to crack the IAS exam."
  }

  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    // Cleanup on component unmount
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  
    return (
      <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Best UPSC Academy in India | Shankar IAS Academy</title>
            <meta name="title" content="Best UPSC Academy in India | Shankar IAS Academy" />
            <meta name="keywords" content="Best IAS Academy in India, Best IAS Coaching Centre in India, Best IAS Academy in Chennai, Best UPSC Coaching in Chennai, Best IAS Academy in Anna Nagar, Best IAS Academy in Tamil Nadu, UPSC Coaching Online, UPSC Coaching in Chennai, IAS Coaching in Anna Nagar" />
            <meta name="description" content="Join Shankar IAS Academy, the best IAS academy in India, for expert UPSC coaching, quality study material, and proven strategies to crack the IAS exam." />
            <link rel="canonical" href=" https://www.shankariasacademy.com/upsc-admission-anna-nagar/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Best UPSC Academy in India | Shankar IAS Academy" />
            <meta property="og:description" content="Join Shankar IAS Academy, the best IAS academy in India, for expert UPSC coaching, quality study material, and proven strategies to crack the IAS exam." />
            <meta property="og:url" content=" https://www.shankariasacademy.com/upsc-admission-anna-nagar/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
            <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
        </Head>

        <Navbar title="upsc" />
         
                <div className="container">
                    <div className="row">
                        <div className="col pt-3 pt-md-4">
                            <div className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}>
                                <Link href="/upsc-admission-anna-nagar"><button id={styles.tablinks} className="nav-link tab1 py-2 px-0 me-4 active" type="button">Anna Nagar</button></Link>
                                <Link href="/adyar"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Adyar</button></Link>
                                <Link href="/bengaluru"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Bengaluru</button></Link>
                                <Link href="/coimbatore"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Coimbatore</button></Link>
                                <Link href="/delhi"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Delhi</button></Link>
                                <Link href="/hyderabad"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Hyderabad</button></Link>
                                <Link href="/thiruvananthapuram"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Thiruvananthapuram</button></Link>
                                <Link href="/trichy"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Trichy</button></Link>
                                <Link href="/salem"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Salem</button></Link>
                                <Link href="/madurai"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Madurai</button></Link>
                                <Link href="/upsc-online-class"><button id={styles.tablinks} className="nav-link tab10 py-2 px-0 me-4" type="button">Online Class</button></Link>
                                <Link href="/upsc-admission-nri"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">NRI</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <Image
                            src={upscbanner1}
                            className="img-fluid w-100 pt-2"
                            alt="Classroom and online coaching"
                            title="Classroom and online coaching"
                          />
                        </div>
                    </div>
                </div>       

{/*<Classroom_form branchname="Annanagar"/> */}

<div className="container-fluid pb-5"  style={{
  background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgb(182, 238, 255 , 29%))",
  opacity: "1",
}}>

<div className="container">
  <div className= "row mt-4 mb-2 ">
    <div class={`${styles.admincontent} col-12  col-md-6 pt-4 mt-4 text-center`}>
      <p><span><Image src={NewiconA} width="15" height="15" alt="New_icon" className="img-fluid mx-2" /></span><span style={{color:'#000', fontWeight:'bold'}}>Shankar IAS Academy </span>stands as a pioneer in UPSC coaching, earning the reputation of being the<span style={{color:'#db1b0d'}}> Best IAS Academy in India</span> through its consistent track record of producing top-ranking civil servants.</p>
      <p><span><Image src={NewiconA} width="15" height="15" alt="New_icon" className="img-fluid mx-2" /></span> As a trusted name in the field of <span style={{color:'#db1b0d'}}>UPSC coaching in Chennai,</span> we are committed to providing aspirants with comprehensive training, result-oriented strategies, and in-depth subject expertise.</p>
      <p><span><Image src={NewiconA} width="15" height="15" alt="New_icon" className="img-fluid mx-2" /></span> Our Chennai, Anna Nagar branch serves as a premier hub for serious UPSC candidates, offering a structured learning environment designed to help students master the complexities of the Civil Services Examination (CSE).</p>
      <p><span><Image src={NewiconA} width="15" height="15" alt="New_icon" className="img-fluid mx-2" /></span> With highly qualified faculty, meticulously curated study materials, and a rigorous assessment framework, we equip aspirants with the knowledge and confidence needed to excel in all three stages of the UPSC exam - Prelims, Mains, and Interview.</p>
    </div>
    <div class="col-12  col-md-6 mt-4 mb-2">
      <p className={`${styles.contactheader} text-center`}>Enquiry</p>
      <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
      <div class={`${styles.addmissionform} npf_wgts `} data-height="600px"   data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
    </div>
  </div>
  </div>
</div>
 <div className="container-fluid">
    <div className={`${styles.bestbg1}`}>
      <div className="row g-4 mt-2">
        <div className="col-12 col-md-6 col-lg-12" id="pregspcm" >
          <div className="card shadow-sm p-4">
             <h2> Pre Booking Open</h2> 
            <p>
              GSPCM will start on 16th February 2026. For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>9003190030</span> 
            </p>
             <div className={`${styles.brochure} justify-content-center`}>
                <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-Chennai-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                     <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                    </button>
                </a>
            </div>
          </div>
        </div>   
      </div>
    </div>
  </div>

  <section id="courseandfees" >
       {/* <div className="container">
      <div className="row pt-2">
      <div className={`${styles.brochure}`}>
      <h2 className={`${styles.sectiontitle} pt-3`}>Course and Fees</h2>
      <button className={`${styles.normalbutton2} ${styles.brochurebtn}`} onClick={() => download(fileUrl, filename)}>
        <Image src={downloadicon} alt="download icon" />
        <p className={`${styles.brochuretxt}`}>Download Brochure</p>
      </button>
      </div>
      </div>
      </div> */}


    <div className="container ">
      <div className="row pt-3 pt-lg-5">    
       <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        <div className="row p-2">
          <div className={`${styles.csatborder} col-lg-8 pt-2`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>General Studies</p>
            <p className={`${styles.sectionsubtitle} mx-3`}>(Preliminary Cum Mains)</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>1,38,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.csatborder} col-lg-4 pt-5`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
         
      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`} style={{ whiteSpace: "pre-line" }}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
             {/* <tr>
           <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>(Video Conference)</b></td> 
              </tr>*/}
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div> 
    

       <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        
         <div className="row p-2">
          <div className={`${styles.csatborder} col-6 col-lg-8 `} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3 pt-4`}>CSAT</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>14,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.csatborder} col-6 col-lg-4 pt-5`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
          

      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure2.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
            {/* <tr>
           <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>(Video Conference)</b></td> 
              </tr>*/}
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div> 


       <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
           <div className="row p-2">
          <div className={`${styles.csatborder} col-6 col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3 pt-4`}>Optional</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>34,000</span></span>
          </div>

          <div className={`${styles.csatborder} col-6 col-lg-4 pt-5`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>


        <div className="pt-3" id="paymentsection">       
         <div className="row mx-auto">
          <div className="col ps-0 ps-xl-0 p-xl-0">
            <div className="table-responsive text-nowrap">
            <table className="table ">
              <tbody>
              {feestructure3.map((item,index)=>(
                <tr key={index}>
                  <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                  <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                  <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                  <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
                </tr>
                ))}
                <tr>
                  <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>Forestry and Geology - After Prelims Result</b></td> 
                </tr>
                {/* <tr>
           <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>(Video Conference)</b></td> 
              </tr>*/}
              </tbody>
            </table>
          </div>
          </div>   
        </div>
      </div>
     
      </div> 

      
     {/* <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
        <ObtionalButton />
      </div> 
             <table>
             
           <tr>
              <td className={`${styles.classacheiverrank} mb-0`}><b><span className={`${styles.sectionredtitle}`} style={{verticalAlign: 'bottom'}}>*</span> (Video Conference)</b></td>
            </tr> 
</table> */}  
         <div className={`${styles.facultyborder3} row p-4 h-100 mb-md-3`}>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                  <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
                  <p className={`${styles.sectionsubtitle} pb-0`}>Total Amount</p>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle} `}><b>₹</b>1,86,000*</span><span>(inclusive of tax)</span></span>

                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2  text-right">
                   <Emioption />
                   
               </div>

               <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
                 <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
               </div>
               <p className={`${styles.aboutparagraph1}  p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;Fees are inclusive of GST & SIA study materials.</p>

      </div>
   
     {/* <div className="row pt-3">
         <a href="https://admissionsv1.shankariasacademy.com/Prebooking-Forms/Step1/step1?center=ANNA_NAGAR&&course=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pre Booking</button></a>
          <button type="button" className={`${styles.normalbutton} ms-3`} onClick={()=>router.push({pathname:"/Prebooking-Forms/Step1/step1",query:"center=ANNA NAGAR&course=UPSC"
             })}>Pre Booking</button> 
              <button type="button" className={`${styles.normalbutton} ms-3`}>Pre Booking</button> 
     </div>*/}
     
     <div className="row">
     {/* <div className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
      <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;<b>₹5,000</b> Discount will be applicable for Integrated Course payment <b>(GS + CSAT + Optional)</b></p>
      </div> */}
      <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
     
      </div>
     </div>

    </div>
    </div>
</section>



<div className={`${styles.sadhana} `}>
  <div className="container">
    <div className="row">
      {/* <div className="col-12 col-md-4 text-white mt-2 p-2 ">UPSC GS-Mains Test Series 2025 (Moksha)<br />
        <a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a>
      </div> */} 

      <div className="col-12 offset-md-4 col-md-4 p-2">
        <Link href="/two-year-upsc-program">
          <Image alt="sadhana" className="img-fluid" src={sadhana} />
        </Link>
      </div>
 
     {/* <div className="col-12 col-md-4 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
        <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
          <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
        </button>
    </div>*/} 
    </div>
  </div>
</div>

{/*Why chose Shankar IAS Academy */}

<div
  className="container-fluid py-5"
  style={{
    background:
      "linear-gradient(to top, rgba(248, 207, 227, 0), rgba(255, 223, 186, 0.5))",
    opacity: "1",
  }}
>
  <div className="row">
    <div className="col-12 text-center">
      <h2 className={`${styles.sectioncont} mb-2`}>Why Choose Shankar IAS Academy?</h2>
      <p className={`${styles.sectiondescription} mb-4`}>
        As the<span style={{color:'#db1b0d'}}> Best IAS Coaching Centre in India,</span> Shankar IAS Academy is committed
        to providing a transformative learning experience for UPSC aspirants. Our
        academy is designed to equip students with in-depth subject knowledge,
        strategic exam preparation, and a structured approach to tackling the Civil
        Services Examination (CSE). Here’s why we are the preferred choice for
        UPSC aspirants across India:
      </p>
    </div>
  </div>

  <div className="row justify-content-center">
    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className={`${styles.featurebox} p-4 shadow-sm rounded`}>
        <div className="text-center">
          <Image
            src={star}
            width="50"
            height="50"
            alt="icon"
            className="iconimg"
          />
        </div>
        <h5 className={`${styles.featuretitle} text-center mb-3`}>Expert Faculty</h5>
        <p className={`${styles.featuredescription}`}>
          We take pride in our team of highly experienced educators, subject matter
          experts, and former civil servants who bring years of real-world
          administrative experience to the classroom. Their expertise helps students
          develop a deep conceptual understanding and master the art of answer writing.
        </p>
      </div>
    </div>

    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className={`${styles.featurebox} p-4 shadow-sm rounded`}>
        <div className="text-center">
          <Image src={meet} width="50" height="50" alt="icon" className="iconimg" />
        </div>
        <h5 className={`${styles.featuretitle} text-center mb-3`}>
          Structured Curriculum
        </h5>
        <p className={`${styles.featuredescription}`}>
          Our well-structured curriculum covers every aspect of the UPSC syllabus,
          ensuring that students receive comprehensive guidance for Prelims, Mains, and
          Interview preparation. We focus on a systematic and topic-wise approach,
          making complex subjects easier to understand.
        </p>
      </div>
    </div>

    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className={`${styles.featurebox} p-4 shadow-sm rounded`}>
        <div className="text-center">
          <Image src={worl} width="50" height="50" alt="icon" className="iconimg" />
        </div>
        <h5 className={`${styles.featuretitle} text-center mb-3`}>High Success Rate</h5>
        <p className={`${styles.featuredescription}`}>
          With hundreds of successful candidates clearing the exam for IAS, IPS, IFS
          and other services every year, we have cemented our reputation as the Best
          UPSC Coaching in Chennai. Our rigorous training programs and proven teaching
          methodologies have helped aspirants secure top ranks in the Civil Services
          Examination.
        </p>
      </div>
    </div>
  </div>

  <div className="row justify-content-center">
    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className={`${styles.featurebox} p-4 shadow-sm rounded`}>
        <div className="text-center">
          <Image
            src={guidance}
            width="50"
            height="50"
            alt="icon"
            className="iconimg"
          />
        </div>
        <h5 className={`${styles.featuretitle} text-center mb-3`}>
          Comprehensive Study Material
        </h5>
        <p className={`${styles.featuredescription}`}>
          We provide regularly updated study materials, notes, and current affairs
          analysis that are aligned with the latest UPSC trends and exam patterns. Our
          resources include NCERT-based notes, standard reference books, and exclusive
          Shankar IAS publications to help students build a strong foundation.
        </p>
      </div>
    </div>

    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className={`${styles.featurebox} p-4 shadow-sm rounded`}>
        <div className="text-center">
          <Image src={test} width="50" height="50" alt="icon" className="iconimg" />
        </div>
        <h5 className={`${styles.featuretitle} text-center mb-3`}>
          Mock Tests & Evaluation
        </h5>
        <p className={`${styles.featuredescription}`}>
          Our full-length mock tests, test series, and daily answer writing practice
          help students gauge their progress, improve time management, and enhance
          their problem-solving skills. We provide detailed performance analysis and
          feedback, enabling aspirants to refine their strategies and address weaknesses
          effectively.
        </p>
      </div>
    </div>

    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className={`${styles.featurebox} p-4 shadow-sm rounded`}>
        <div className="text-center">
          <Image
            src={mentor}
            width="50"
            height="50"
            alt="icon"
            className="iconimg"
          />
        </div>
        <h5 className={`${styles.featuretitle} text-center mb-3`}>Personalized Mentorship</h5>
        <p className={`${styles.featuredescription}`}>
          Understanding that every aspirant’s journey is unique, we offer one-on-one
          mentorship and personalized guidance to help students overcome challenges,
          improve their weak areas, and build confidence. Our mentors provide motivational
          support, exam-oriented strategies, and career counseling to ensure students
          stay focused and achieve their IAS dreams.
        </p>
      </div>
    </div>
    <div className="col-12 col-md-6 mb-4">
    <p className="text-center mt-4">
      With our student-centric approach, well-researched study plans, and commitment
      to excellence, Shankar IAS Academy continues to be the<span style={{color:'#db1b0d'}}> Best IAS Academy in Chennai,
      Tamil Nadu, and India,</span> shaping future civil servants who will lead the nation.
    </p>
    </div>
  </div>
</div>

<Program_Features />



{/* Our Acheivers */}
<section id="toppers">

      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-xl-5 text-center">
            <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
            <p className={`${styles.sectionsubtitle}`}>
              Rank Holders from our academy
            </p>
          </div>
        </div>
      </div>
  </section>

    <Acheiver />
    <section id="toppers">

      <div className="container">
        <div className="row">
         <div className="col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
          <Optionalplus /> 
          </div>
          <div className={`${styles.oneplusbox}`}>
  
    {/* <div className="container">
    <h4 className={`${styles.plus} mb-0 `}>General Studies Prelims Only Batch</h4>
   
      <div className="row ">
      
              <div className="col-xl-4 col-lg-4 col-md-6 col-6 pt-2 "> 
                <p className={`${styles.para} `}>Fee</p> 
                <span className={`${styles.para} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>60,000</span></span>
                
              </div>
              <div className=" ofset-1 col-xl-4 col-lg-4 col-md-6 col-6 pt-2 ">

              <ul>
              <li className={`${styles.acheiverrank} `}><span className={`${styles.dot} pe-2`}>*</span>Regular - Online / Offline </li>
              <li className={`${styles.acheiverrank} `}><span className={`${styles.dot} pe-2`}>*</span>21.11.2024</li>
              <li className={`${styles.acheiverrank} `}><span className={`${styles.dot} pe-2`}>*</span>08:00 am to 01:30 pm</li> <br/>
              <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink} `}><button type="button" className={`${styles.plusbutton} `}>Pay Here</button></a>
              </ul>

              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-6 p-md-2 ">
              <a href="#" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}></a>
              </div>
              </div>



              </div> */}
          
                
               
              
      </div>
        </div>
      </div>
  </section>


  <section id="courses">
  <div className="container-fluid">
    <div className={`${styles.bestbg}`}>
      <h4 className="text-center">Best IAS Academy in Chennai - Comprehensive UPSC Courses Offered</h4>
      <h6 className="text-center">
        At Shankar IAS Academy, we provide a diverse selection of courses carefully <br/> designed to meet the unique requirements of UPSC aspirants:
      </h6>

      <div className="row g-4 mt-2">
     
        <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <div className="card-icon">
              <i className="fas fa-chalkboard-teacher"></i>
            </div>
            <h5>UPSC Prelims & Mains Coaching</h5>
            <p>
            Our comprehensive Prelims and Mains coaching program is structured to provide in-depth subject coverage, extensive current affairs analysis, and rigorous test series to help aspirants clear both stages with confidence.
            </p>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <div className="card-icon">
              <i className="fas fa-book"></i>
            </div>
            <h5>Optional Subject Coaching</h5>
            <p>
            Choosing the right optional subject is crucial for securing a top rank in UPSC Mains. We offer specialized coaching for high-scoring and popular optional subjects, including – Sociology, Economics, Geography, Public Administration, Political Science, Anthropology, Tamil Literature, Mathematics, Agriculture and more.
            </p>
          </div>
        </div>

       
        <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <div className="card-icon">
              <i className="fas fa-users"></i>
            </div>
            <h5>UPSC Interview Guidance Program</h5>
            <p>
            The Personality Test (Interview) is the final stage of the UPSC selection process, and it requires confidence, presence of mind, and strong communication skills. Our Interview Guidance Program includes:
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>One-on-one Mock Interviews conducted by retired civil servants, subject experts, and senior bureaucrats.</li>
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>MCQ-Based Questions & Current Affairs Discussions to enhance knowledge and spontaneity.</li>
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Personality Development Sessions to improve articulation, confidence, and presentation.</li>
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Individual Feedback & Performance Analysis to help aspirants refine their approach and maximize their scores.</li>
            </ul>
          </div>
        </div>

       
        <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <div className="card-icon">
              <i className="fas fa-book-open"></i>
            </div>
            <h5>NCERT Foundation Course</h5>
            <p>
            A strong foundation is the key to UPSC success. Our NCERT Foundation Course is designed for beginners and undergraduate students who aim to build a solid conceptual base before diving into advanced topics.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> <span style={{fontWeight:'600'}}>Comprehensive NCERT Coverage –</span> Subject-wise detailed explanation of History, Geography, Polity, Economics, and Science & Technology. </li>
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> <span style={{fontWeight:'600'}}>Basic to Advanced Approach – </span>Simplified teaching methods that gradually introduce complex concepts.</li>
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span><span style={{fontWeight:'600'}}> Answer Writing & Analytical Thinking Development –  </span>Focus on exam-oriented approach and conceptual clarity.</li>
              
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
    
  {/* CSAT Program 
    <div className="container pt-3">
        <div className="col-12">
          <div className="csattable">
            <div className="row csathead">
              <div className="col-12 col-lg-2">
                  <p className={`${styles.tableheading1} mb-0`}>CSAT</p>
              </div>
              <div className="col-12 col-lg-4">
                  <p className={`${styles.tablepara1} mb-0`}>27th January 2024<br/>(Weekend	09:00 am to 01:00 pm)</p>
              </div>
              <div className="col-12 col-lg-2">
                  <p className={`${styles.tablepara1} mb-0`}>₹ 22,000</p>
              </div>
              <div className="col-12 col-lg-4">
                  <p  className={`${styles.tablepara1} mb-0`}>Admission - <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></p>
              </div>
            </div>
          </div>
        </div>
    </div>*/}
    
{/* Fee Details Section */}


  <section id="courses">
  <div className="container-fluid">
    <div className={`${styles.bestbg}`}>
      <h4 className="text-center pb-2">Best UPSC Coaching in Chennai - Admissions Open</h4>
      
      <div className="row g-4 mt-4">
     
        <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <p>
            Take the first step toward your IAS dream by joining the <span style={{color:'#e11212'}}> Best IAS Academy in Anna Nagar.</span> With a proven track record of success, expert faculty, and a structured learning approach, Shankar IAS Academy has helped countless aspirants secure top ranks in the UPSC Civil Services Examination. 
            </p>

            <p>
            As the <span style={{color:'#e11212'}}> Best IAS Academy in Tamil Nadu,</span> we are committed to providing high-quality coaching, personalized mentorship, and result-driven strategies to help you excel. 
            </p>

            <p>
            <span style={{color:'#e11212'}}>Admissions are now open - </span>secure your spot and start your journey toward becoming a civil servant today!
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

 {/* Location Section */}
 
{/* <div className="container">
  <div className="row pt-3">
      <div className="col">
         <h2 className={`${styles.sectiontitle} mb-2`}>Venue</h2>
         <p className={`${styles.sectionsubtitle} mb-1`}>Shankar IAS Academy</p>
         <p className={`${styles.acheiverrank} mb-0`}>Door No 18, Old Plot No 109,</p>
         <p className={`${styles.acheiverrank} mb-0`}>New Plot No 259, AL Block, 4th Avenue,</p>
         <p className={`${styles.acheiverrank} mb-0`}>Shanthi Colony, Annanagar,</p>
         <p className={`${styles.acheiverrank}`}>Chennai 600040.</p>       
      </div>
      <p className={`${styles.acheivername}`}><Image src={phone} alt="Shankar IAS Academy annanagar contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:76677 66266" className={`${styles.numberbold}`}>76677 66266</a> <b>.</b> <a href="tel:044-66024500" className={`${styles.numberbold}`}>044-66024500</a></p>
      <a href="https://www.google.com/maps/place/Shankar+IAS+Academy/@13.0824591,80.2026201,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x9b278e8700a30d6!8m2!3d13.0824945!4d80.2048109" target="_blank"  rel="noreferrer" className={`${styles.redunderlinealink}`} style={{whiteSpace: "nowrap"}}>Get Direction</a>
  </div>
</div> */}

{/* <div className="container">   
  <div className="row pt-5">
    <div className="col">
      <p className={`${styles.sectionsubtitle} mb-2`}>Best Online UPSC Coaching – Shankar IAS Academy</p>
      <p className={`${styles.acheiverrank}`}>Shankar IAS Academy, one of the best UPSC online coaching academy with professional and experienced personal coaches. 
        More than 1500 students have passed the UPSC, IAS, and IPS exams after attending our IAS, IPS, and UPSC online classes. 
        Now, it's your chance to clear the IAS exam that too at the first attempt by joining our online coaching for UPSC today.</p>
        <p className={`${styles.sectionsubtitle} mb-2`}>Enroll in IAS online coaching today and reach your dream of success!</p>
        <p className={`${styles.acheiverrank}`}>Getting ready for the UPSC Civil services exam is very easy for those who pick the smart way of learning. 
          Exploring the unique strategy as per the time constraints and your requirements are vital to excel in UPSC, IAS, and IPS exams.</p>
        <p className={`${styles.acheiverrank}`}>So what is the unique strategy that can make you excel in UPSC Civil Exams?</p>
        <p className={`${styles.acheiverrank}`}>Yes, you guessed it right. It's the top-rated Civil Services Online Coaching by 
          Shankar IAS Academy, which provides the best UPSC, IPS, and IAS online coaching classes videos 
          in different languages. Lockdown due to Covid-19 has changed the complete lifecycle of the humans.
          Most of them have started opting for IAS online classes as its only option available in the lockdown. 
          Apart from that, the UPSC online class is convenient and affordable when compared to regular UPSC coaching. 
          The class timings are also made flexible as per the students' availability, which is a fantastic reason 
          why many aspirants choose online IAS coaching today.</p>
        <p className={`${styles.acheiverrank}`}>Shankar IAS Academy, the most preferred UPSC CSE online coaching, delivers you the updated UPSC lectures, 
          current affairs from the most reliable and competent UPSC faculty on your laptops, mobile, and other smart devices. 
          We have experienced and professionals faculties who deliver informative and short online classes for 
          UPSC, IAS, and IPS in a video format so that the aspirants can check it whenever they require relevant information about the topic.</p>
        <p className={`${styles.acheiverrank}`}>Homemakers and working professionals who wish to become IAS or IPS will not be able to go to an academy and learn the course. 
          Shankar IAS Academy provides online coaching for IAS, IPS, and UPSC, which are the best alternative to 
          standard IAS, IPS, and UPSC classroom program. We have regular assessment and feedback system that ensures, 
          everyone who attends the UPSC online courses have access to the self-evaluation system. It can make them 
          identify areas where they are weak and continuously work on those areas to groom them well. Our faculties 
          strive to make the aspirants of Shankar IAS Academy achieve their dream career sooner and easier.</p>
        <p className={`${styles.sectionsubtitle} mb-2`}>Why choose Shankar IAS Academy for IAS, IPS, and UPSC Online coaching?</p>
        <ul>
          <li className={`${styles.acheiverrank}`}>Shankar IAS Academy is the excellent UPSC coaching institute for civil services examination to get enrolled in 
            various public services of the Indian Government, namely IPS (Indian Police Service), IFS (Indian Forest Service), 
            and IAS (Indian Administrative Service).</li>
          <li className={`${styles.acheiverrank}`}>We have an excellent crew of faculties who are experienced people and have helped plenty of students 
            and professionals to clear the UPSC examinations at the first attempt. We provide study materials, 
            current affairs magazines, answer composing rehearses, test series that include general studies and 
            current affairs, infographics, essential documents, and pattern investigation as a part of the Online IAS coaching classes.</li>
          <li className={`${styles.acheiverrank}`}>We offer personalized attention who are a part of the online UPSC coaching and provide them the right feedback to get them improved.</li>
          <li className={`${styles.acheiverrank}`}>Online live classes, recorded videos, course structure of online courses, subject-wise courses, and the flexibility of choosing your 
            preferred time, are some of the advantages that Shankar IAS Academy provide aspirants as the best online coaching academy for IAS, IPS, and UPSC.</li>
          <li className={`${styles.acheiverrank}`}>Shankar IAS Academy provides LMS access, online live classes, online class tests, E-Magazine (current affairs), online test series for both Mains and Prelims, 
            class notes/ Study materials (Digital), and more after online live class admissions which is not available in other IAS Academies.</li>
        </ul>
    </div>
  </div>
</div> */}
      
      <BranchAddress />
      <Interest />
      <Footer />                        
      </>
    )
  }
  
  export default UPSCClassroomOnline;
